import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */

const IconMinus = () => {
    return (
        <svg
            fill='none'
            height='2'
            viewBox='0 0 12 2'
            width='12'
            xmlns='http://www.w3.org/2000/svg'>
            <path d='M0 0V1.25L12 1.25V4.76837e-07L0 0Z' fill='#FC5200'/>
        </svg>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default IconMinus;
